import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container, Row, Col, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { SiMicrosoftexcel } from 'react-icons/si'
import { obtenerInformesPrevios} from '../../store/actions/informes-administracion-action'
import {Auth, LoadingComponent} from 'recupero-comunes'

const InformePrevios = () => {
    const dispatch = useDispatch()
    const [loading, setLoading]=useState(false)
    const data_informes = useSelector((state) => state.informeAdministracionReducer)
    const { cfg_formInf, listaInformesPrevios } = data_informes
    const {rutUsuario, rutOrganizacion} = Auth.currentUser()

    const TIPO_INFORME_INFORMES_PROFESIONALES = 282004;
    const TIPO_INFORME_HONORARIOS = 999999;

    const obtenerColumnas = () => {

        return [
            { 
                dataField: 'id', text: cfg_formInf ? cfg_formInf.cfg_formInf['informes-grilla-id']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'fechaEmision', text: cfg_formInf ? cfg_formInf.cfg_formInf['informes-grilla-fecha']:'', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'tipoInforme', text: cfg_formInf ? cfg_formInf.cfg_formInf['informes-grilla-tipo']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'cntRegistros', text: cfg_formInf ? cfg_formInf.cfg_formInf['informes-grilla-cntcasos']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            {
                dataField: 'estadoEmision', text:cfg_formInf ? cfg_formInf.cfg_formInf['informes-grilla-estado']:'', sort: true, headerAlign: 'center', align: 'center'
                ,headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            {
                dataField: 'usuario', text: cfg_formInf ? cfg_formInf.cfg_formInf['informes-grilla-usuario']:'', sort: true, headerAlign: 'center', align: 'center'
                , headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },           
            {
                dataField: 'accion', text:cfg_formInf ? cfg_formInf.cfg_formInf['informes-grilla-accion']:'' , isDummyField: true,  headerAlign: 'center', align: 'center' ,
                
                formatter: (cell, row) => (
                    <div>
                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Informe </Tooltip>}>
                        <Button type="button" variant="outline-success" size="sm"  onClick={()=>{
                            
                            handleVerInforme(row)}}>
                            
                            <SiMicrosoftexcel  />
                        </Button>
                        </OverlayTrigger>
                    </div>
                )
                , headerStyle:{color:'white', backgroundColor:'#7594C1',verticalAlign: 'middle'}
            }
        ];
    }
    const handleReload = () => {
        let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
        setLoading(true);
        dispatch(obtenerInformesPrevios(query))
        .then(()=>setLoading(false))
    }
    const handleVerInforme=(row)=>{
        if(row.url){
            let link = document.createElement("a");
            link.href = row.url;
            link.click();
        }           
    }
    const informesFiltrados = (listaInformesPrevios && listaInformesPrevios.length > 0)
        ? listaInformesPrevios.filter(inf => (inf.codTipoInforme !== TIPO_INFORME_INFORMES_PROFESIONALES && inf.codTipoInforme !== TIPO_INFORME_HONORARIOS))
        : [];
    return ( 
        <div>  
             <LoadingComponent show={loading}/>
            { cfg_formInf ? 
            <Card >
                <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white', textAlign:'center' }}>
                    {cfg_formInf.cfg_formInf['informes-informes-previos-title']}
                </Card.Header>
                <ToolkitProvider search bootstrap4 keyField="id" 
                    data={ informesFiltrados } 
                    columns={ obtenerColumnas() } defaultSorted={ [{ dataField: 'id', order: 'asc' }] }>
                    { 
                    props =>                   
                        <div>
                            <Row>                         
                                <Col md={12} className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                                    
                                    <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                                    <Button className="mx-2" type="button" variant="outline-info" size="sm" onClick={() => { handleReload() }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                        </svg>
                                    </Button>
                                
                                </Col>                           
                            </Row>
                            <BootstrapTable { ...props.baseProps } headerWrapperClasses="table-secondary" pagination={ paginationFactory() } noDataIndication={<div className="text-center">No hay registros encontrados</div>} />
                        </div>
                    }
                </ToolkitProvider>
            </Card>
            : null }
        </div>
    )
}
export default InformePrevios 